export const investorRelationsPreviewQuery = `
    {
      "calendarEvents": {
        "nodes": *[_type == "calendarEvent" && startDate != null] | order(startDate asc) {
          _id,
          _type,
          endDate,
          i18nLang,
          startDate,
          title
        }
      },
      "financialCalendars": {
        "nodes": *[_type == "financialCalendar" && slug.current != null] {
          i18nLang,
          slug {
            current
          }
        }
      },
      "pressReleaseLists": {
        "nodes": *[_type == "pressReleaseList" && slug.current != null] {
          i18nLang,
          slug {
            current
          }
        }
      },
      "pressReleases": {
        "nodes": *[
          _type == "pressRelease" && 
          slug.current != null && 
          pressReleaseType != "report"
        ] | order(publishDate desc) {
          _type,
          i18nLang,
          publishDate,
          slug {
            current
          },
          teaserDescription,
          title
        }
      },
      "reports": {
        "nodes": *[
          _type == "pressRelease" && 
          slug.current != null && 
          pressReleaseType == "report"
        ] | order(publishDate desc) {
          _type,
          i18nLang,
          publishDate,
          slug {
            current
          },
          teaserDescription,
          title
        }
      },
    }
  `;
